var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'live-icon',
    !_vm.active && (_vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-2'),
    _vm.active && 'live-icon--active red darken-3 red--text lighten-2--text' ]})}
var staticRenderFns = []

export { render, staticRenderFns }